var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaiStateRepIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#haiStateRepIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6Zm0 9a.75.75 0 1 1 0-1.5A.75.75 0 0 1 6 9Zm.75-2.625a.375.375 0 0 1-.375.375h-.75a.375.375 0 0 1-.375-.375v-3c0-.207.168-.375.375-.375h.75c.207 0 .375.168.375.375v3Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "haiStateRepIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgHaiStateRepIcon;